export const APP_VERSION = import.meta.env.VITE_COMMIT_HASH || 'dev';
